import type { BoxTruckDocumentScope } from '../utils/analytics'
import { DocumentsCompact, type DocumentChip } from './DocumentsCompact'

/**
 * The document shape the OWNER and ASSET records use.
 *
 * Driver documents are addressed by their private GCS path; these two by a `documentId` the server
 * resolves. That difference is the address, not the rendering — which is why both strips are one component
 * with the address passed in.
 */
export interface AttachedDocument extends DocumentChip {
    documentId: string
    uploadedAt?: Date | string
}

/**
 * Read-only documents strip for the records a driver is ATTACHED to — the owner's W-9 and carrier contract,
 * the vehicle's registration and insurance.
 *
 * An operator checking whether a driver may be dispatched was going to the Owners screen for one and the
 * Assets screen for the other, having first worked out which owner and which vehicle from a raw id.
 */
export const AttachedDocumentsCompact = ({
    docs,
    labels,
    scope,
    fetchBlobUrl,
    emptyText,
}: {
    docs: AttachedDocument[]
    labels?: Record<string, string>
    scope: BoxTruckDocumentScope
    fetchBlobUrl: (documentId: string) => Promise<string>
    emptyText: string
}) => (
    <DocumentsCompact
        docs={docs}
        labels={labels}
        scope={scope}
        keyOf={(doc) => doc.documentId}
        openFor={(doc) => fetchBlobUrl(doc.documentId)}
        emptyText={emptyText}
    />
)
